var DataService = (function () {
  const ROOT = "https://hocdata.yifanchen.io/translations/";
  const FETCHBUFFERSECONDS = 2;
  const CACHEDTRANSLATIONSSIZE = 20;

  let cachedTranslationsVideoId = "";
  let cachedTranslationsRange = [0, 0];
  let cachedTranslations = [];
  let currentTranslation = "";

  const clearTranslations = () => {
    cachedTranslations = [];
    currentTranslation = "";
  };

  const getTranslation = (playerProgress) => {
    if (!playerProgress) {
      return "";
    }

    if (
      cachedTranslationsVideoId !== playerProgress["videoId"] ||
      cachedTranslationsRange[1] - playerProgress["seconds"] <
        FETCHBUFFERSECONDS ||
      playerProgress["seconds"] < cachedTranslationsRange[0]
    ) {
      fetchTranslations(playerProgress);
    }

    return findTranslation(playerProgress);
  };

  const findTranslation = (playerProgress) => {
    const matchingTranslation = cachedTranslations.find((cachedTranslation) => {
      return (
        cachedTranslation["seconds"] === playerProgress["seconds"] &&
        cachedTranslation["video_id"] === playerProgress["videoId"]
      );
    });
    if (matchingTranslation) {
      currentTranslation = matchingTranslation["translation"];
    }
    currentTranslation = handleEpisodeOne(currentTranslation, playerProgress);
    return currentTranslation;
  };

  const handleEpisodeOne = (currentTranslation, playerProgress) => {
    if (playerProgress["videoId"] === "CTRvs6bW6CQ") {
      return "";
    } else {
      return currentTranslation;
    }
  };

  const fetchTranslations = async (playerProgress) => {
    const url = buildUrl(playerProgress);
    const res = await fetch(url);
    const data = await res.json();
    const translations = data["data"];
    if (translations.length) {
      cachedTranslations = translations;
      cachedTranslationsVideoId = translations[0]["video_id"];
      cachedTranslationsRange = [
        translations[0]["seconds"],
        translations[translations.length - 1]["seconds"],
      ];
    }
  };

  const buildUrl = (playerProgress) => {
    let url = new URL(ROOT + playerProgress["videoId"]);
    const params = {
      seconds: playerProgress["seconds"],
      limit: CACHEDTRANSLATIONSSIZE,
    };
    url.search = new URLSearchParams(params).toString();
    return url;
  };

  return {
    getTranslation: getTranslation,
    clearTranslations: clearTranslations,
  };
})();

export default DataService;
